import { Button, Flex, Heading, Image, Text } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import image from "../assets/unauthorized.png";

export default function Unauthorized() {
  const navigate = useNavigate();
  return (
    <Flex
      minHeight="var(--page-height)"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap={6}
    >
      <Flex maxW={480}>
        <Image src={image} alt="unauhtorized" />
      </Flex>
      <Flex flexDirection="column" alignItems="center">
        <Heading size="lg" mb={1}>
          Oops!
        </Heading>
        <Text fontSize={12}>Anda harus login terlebih dahulu</Text>
      </Flex>
      <Button
        fontSize={14}
        width="100%"
        maxWidth={400}
        colorScheme="orange"
        onClick={() => navigate("/profile")}
      >
        Login
      </Button>
    </Flex>
  );
}
